<!-- 加入我们 -->
<template>

    <div class="box">

        <full-page :options="options" id="fullpage" ref="fullpage">
            <div class="section section1">
                <div @click="istab = false" v-show="istab" class="tabbox">
                    <div class="hadtabs">
                        <ul>
                            <li class="active">
                                <router-link to="/h5home">官网首页</router-link>
                            </li>
                            <li>
                                <router-link to="/h5recharge">账户充值</router-link>
                            </li>
                            <li>
                                <router-link to="/h5enlist">主播招募</router-link>
                            </li>
                            <!-- <li>
                                <router-link to="/h5aboutus">关于我们</router-link>
                            </li> -->
                            <li>
                                <router-link to="/h5contactus">联系我们</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="box1">
                    <a href="#" class="logo"></a>
                    <button @click="istabshow()" class="tabiocn"></button>

                    <div class="title_icon"> </div>
                    <button @click="download()" class="dowlod topdowlod_btn"></button>
                    <i class="down_icon"></i>
                </div>
            </div>
            <div class="section">
                <div class="box2">
                    <div class="box2bg">
                        <div class="shoujibox">
                            <div :class="[isbox2ani ? 'box2ani' : '', 'shouji']"></div>
                            <div :class="[isbox2ani ? 'girl1ani' : '', 'girl1']"></div>
                        </div>
                    </div>
                    <button @click="download()" class="dowlod"></button>
                    <i class="down_icon_red"></i>
                </div>

            </div>
            <!-- <div class="section">
                <div class="box3">
                    <div class="box3bg">
                        <div class="box3_shouji">
                            <div :class="[isbox3ani ? 'box3shoujibgani' : '', 'box3shoujibg']"></div>
                            <div :class="[isbox3ani ? 'box3girlani' : '', 'girl2']"></div>
                            <div :class="[isbox3ani ? 'box3boyani' : '', 'boy2']"></div>
                        </div>

                    </div>
                    <button @click="download()" class="dowlod"></button>
                    <i class="down_icon_red"></i>
                </div>

            </div> -->
            <!-- <div class="section">
                <div class="box4">
                    <div class="box4bg">
                        <div class="box4_shouji">
                            <div :class="[isbox4ani ? 'box4shoujibgani' : '', 'box4shoujibg']"></div>
                            <div :class="[isbox4ani ? 'box4pic_gift' : '', 'pic-gift']" class="pic-gift"></div>
                            <div :class="[isbox4ani ? 'box4girl3' : '', 'girl3']" class="girl3"></div>
                        </div>
                    </div>
                    

                </div>
            </div> -->
           <div class="section">
                 <Footer></Footer>
           </div>
         
        </full-page>
        <div class="pic_guide_jiaren" v-if="is_weixin">
            <div class="pic_guide_img"></div>
        </div>
    </div>
</template>
<script>
import Footer from "../../components/h5footer"
export default {
    components: {
        Footer
    },
    data() {
        return {
            isIOS: false,
            istab: false,
            options: {
                licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
                afterLoad: this.afterLoad,
                // navigation: true,
                menu: '#menu',
                // anchors: ['page1', 'page2', 'page3'],
                sectionsColor: []
            },
            isbox2ani: false,
            isbox3ani: false,
            isbox4ani: false,
            is_weixin: false,
        }
    },
    created() {
        this.isIOS = this.isIos()

        this.ispic_guide_jiaren()
    },
    methods: {
        download() {

            if (this.isIos()) {
                // alert('暂时不能下载，敬请期待');
                window.location.href = "https://api.imbeiyu.com/call.do?cmd=download.getUrl&isIos=1"
                return;
            }
            window.location.href = "https://api.imbeiyu.com/call.do?cmd=download.getUrl"
        },
        ispic_guide_jiaren() { // 是否显示蒙层
            this.is_weixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
            // console.log('this.is_weixin',this.is_weixin)
        },
        istabshow() {
            console.log(888)
            this.istab = true
        },
        afterLoad: function (origin, destination, direction) {
            console.log(destination);
            if (destination.index == 0) {
                this.isbox2ani = false

            } else if (destination.index == 1) {
                this.isbox2ani = true
                this.isbox3ani = false

            } else if (destination.index == 2) {
                this.isbox3ani = true
                this.isbox4ani = false

            } else if (destination.index == 3) {
                this.isbox4ani = true
            }
        },
        isIos() {
            var equipmentType = "";
            var agent = navigator.userAgent.toLowerCase();
            var android = agent.indexOf("android");
            var iphone = agent.indexOf("iphone");
            var ipad = agent.indexOf("ipad");
            if (android != -1) {
                equipmentType = false;
            }
            if (iphone != -1 || ipad != -1) {
                equipmentType = true;
            }
            return equipmentType;
        }
    },
}
</script>
<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;

    .pic_guide_jiaren {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 1);
        z-index: 999;

    }

    .pic_guide_img {
        background: url('https://resource.imbeiyu.com/lhp/202000619/img/pic_guide_jiaren.png');
        background-size: 100% 100%;
        width: 100%;
        height: 7.45rem;
        position: absolute;
        top: 0;
    }

    .section1 {
        position: relative;
        width: 100%;
        height: 100%;

        .tabbox {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.6);
            z-index: 999;
            // .tabs{
            //   width:2.67rem; position: absolute;
            //     height:5.41rem;top: 1.55rem; right: .21rem;
            //     background:rgba(255,255,255,1); border-radius: .3rem;
            //     box-shadow:0rem 0rem 0.27rem 0rem rgba(0,0,0,0.1);  
            //      animation: tabs .5s; overflow: hidden;
            //     ul{
            //         width: 100%;padding: 0 .48rem; box-sizing: border-box;
            //         li{
            //             a{
            //                 height: 1.33rem; border-bottom: 1Px solid #E6E6E6; text-align: center;
            //                 font-size: .37rem; line-height: 1.33rem; width: 100%; color:#505050;
            //             }

            //         }
            //         .active{
            //           color: #FF205E;
            //         }
            //     }
            // }
            @keyframes tabs {

                0%,
                to {
                    height: 1rem;
                }

                100% {
                    height: 5.41rem;
                }
            }
        }


    }

    .box1 {
        background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/bg-h5.png');
        background-size: 100% 100%;
        width: 100%;
        position: relative;
        height: 100%;
        padding: .43rem;
        box-sizing: border-box;

        .tabiocn {
            display: block;
            background: url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-more-white.png');
            background-size: 100% 100%;
            width: .7rem;
            position: absolute;
            top: .42rem;
            right: .43rem;
            height: .75rem;
            z-index: 99;
        }


        .logo {
            display: block;
            background: url('https://resource.imbeiyu.com/nnxqGw/img/h5-logo-white2.png');
            background-size: 100% 100%;
            width: 3.47rem;
            height: .8rem;
        }

        .title_icon {
            background: url('https://resource.imbeiyu.com/gw/assets/images/h5/pic-slogan2.png');
            background-size: 100% 100%;
            width: 7rem;
            margin: 30% auto 0 auto;
            height: 5.3rem;
            animation: title_icon 1.5s;
            opacity: 1;
        }

        .dowlod {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 1.2rem;
            animation: dowlod 1.5s;
            opacity: 1;
        }

        .down_icon {
            background: url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-down-white.png');
            background-size: 100% 100%;
            width: .4rem;
            height: .37rem;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: .5rem;
            animation: jump 2s infinite;
        }

        @keyframes title_icon {

            0%,
            to {
                opacity: 0;
                margin: 40% auto 0 auto;
            }

            100% {
                opacity: 1;
                margin: 30% auto 0 auto;
            }
        }

        @keyframes dowlod {

            0%,
            to {
                opacity: 0;
                bottom: 0.15rem;
            }

            100% {
                opacity: 1;
                bottom: 1.2rem;
            }
        }

    }

    .box2 {
        width: 100%;
        height: 100%;
        position: relative;

        .box2bg {
            background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/bg-list1.png');
            background-size: cover;
            padding-top: 2.45rem;
            box-sizing: border-box;
            width: 100%;
            position: relative;
            height: 14.75rem;
        }

        .shoujibox {
            width: 5.15rem;
            position: relative;
            height: 9.9rem;
            margin: 0 auto 0 auto;

            .shouji {
                background: url('https://resource.imbeiyu.com/nnxqGw/img/pic-phone3.png');
                opacity: 0;
                background-size: 100% 100%;
                width: 100%;
                height: 100%;
            }

            .girl1 {
                position: absolute;
                bottom: .3rem;
                right: 0;
                opacity: 0;
                background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/pic-girl1.png');
                background-size: 100% 100%;
                width: 4.16rem;
                height: 5.47rem;
            }
        }
    }

    .box3 {
        width: 100%;
        height: 100%;
        position: relative;

        .box3bg {
            background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/bg-list2.png');
            background-size: cover;
            width: 100%;
            height: 14.75rem;
            padding-top: 2.45rem;
            box-sizing: border-box;
        }

        .box3_shouji {
            position: relative;
            width: 5.15rem;
            height: 9.9rem;
            margin: 0 auto 0 auto;

            .box3shoujibg {
                background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/pic-phone2.png');
                opacity: 0;
                background-size: 100% 100%;
                width: 100%;
                height: 100%;

            }

            .girl2 {
                position: absolute;
                bottom: .3rem;
                left: -2rem;
                opacity: 0;
                background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/pic-girl2.png');
                background-size: 100% 100%;
                width: 5.52rem;
                height: 5.89rem;
            }

            .boy2 {
                position: absolute;
                bottom: .3rem;
                right: -2.02rem;
                opacity: 0;
                background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/pic-boy2.png');
                background-size: 100% 100%;
                width: 5.82rem;
                height: 6rem;
            }

        }
    }

    .box4 {
        width: 100%;
        height: 100%;
        position: relative;

        .box4bg {
            background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/bg-list3.png');
            background-size: cover;
            width: 100%;
            height: 12.35rem;
            padding-top: 2.45rem;
            box-sizing: border-box;
        }

        .box4_shouji {

            width: 5.15rem;
            position: relative;
            height: 9.9rem;
            margin: 0 auto 0 auto;

            .box4shoujibg {
                background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/pic-phone3.png');
                background-size: 100% 100%;
                width: 100%;
                height: 100%;
                opacity: 0;
            }

            .pic-gift {
                position: absolute;
                bottom: .3rem;
                left: -2.4rem;
                opacity: 0;
                background: url('https://resource.imbeiyu.com/gw/assets/images/h5/pic-gift.png');
                background-size: 100% 100%;
                width: 7rem;
                height: 5.49rem;
            }

            .girl3 {
                position: absolute;
                bottom: .3rem;
                right: -2.02rem;
                opacity: 0;
                background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/pic-girl3.png');
                background-size: 100% 100%;
                width: 5.82rem;
                height: 6.5rem;
            }

        }


    }

    .down_icon_red {
        background: url('https://resource.imbeiyu.com/gw/assets/images2/h5/icon-down-red.png');
        background-size: 100% 100%;
        width: .4rem;
        height: .37rem;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: .5rem;
        animation: jump 2s infinite;
    }

    .dowlod {
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 1.2rem;
        background: url('https://resource.imbeiyu.com/gw/assets/images/h5/btn_download.png');
        background-size: 100% 100%;
        width: 5.28rem;
        height: 1.28rem;
    }

    @keyframes dowlod {

        0%,
        to {
            opacity: 0;
            bottom: -3.15rem;
        }

        100% {
            opacity: 1;
            bottom: 1.2rem;
        }
    }

    @keyframes jump {

        0%,
        to {
            transform: translate(-50%, 0);
        }

        50% {
            transform: translate(-50%, 50%);
        }
    }
}

.box .box2 .shoujibox .box2ani {
    animation: shouji 1s;
    opacity: 1;
    transform: translateY(0)
}

.box .box2 .shoujibox .girl1ani {
    animation: girl1 1.2s;
    opacity: 1;
}

.box .box3 .box3_shouji .box3girlani {
    animation: girl2 1.5s;
    opacity: 1;
}

.box .box3 .box3_shouji .box3boyani {
    animation: boy2 1.5s;
    opacity: 1;
}

.box .box3 .box3_shouji .box3shoujibgani {
    animation: box3shoujibgani .8s;
    opacity: 1;
}

.box .box4 .box4_shouji .box4shoujibgani {
    animation: box3shoujibgani .8s;
    opacity: 1;
}

.box .box4 .box4_shouji .box4pic_gift {
    animation: gift 1.5s;
    opacity: 1;
}

.box .box4 .box4_shouji .box4girl3 {
    animation: girl3 1.5s;
    opacity: 1;
}

@keyframes box3shoujibgani {

    0%,
    to {
        opacity: 0;
        transform: translateY(-4%)
    }

    100% {
        opacity: 1;
        transform: translateY(0)
    }
}

@keyframes shouji {

    0%,
    to {
        opacity: 0;
        transform: translateY(-4%)
    }

    100% {
        opacity: 1;
        transform: translateY(0)
    }
}

@keyframes girl1 {
    0% {
        opacity: 0;
        transform: translateY(-30%)
    }

    100% {
        opacity: 1;
        transform: translateY(0)
    }
}

//  @keyframes dowlod {  
//         0%,to{opacity:0; bottom: -2.15rem;}100%{opacity:1;bottom: 2.15rem;}
// }    
@keyframes girl2 {
    0% {
        opacity: 0;
        left: -3.15rem;
    }

    50% {
        opacity: .8;
        left: -1.5rem;
    }

    100% {
        opacity: 1;
        left: -2rem;
    }
}

@keyframes boy2 {
    0% {
        opacity: 0;
        right: -3.15rem;
    }

    50% {
        opacity: .8;
        right: -1.5rem;
    }

    100% {
        opacity: 1;
        right: -2.02rem;
    }
}

@keyframes gift {
    0% {
        opacity: 0;
        width: 5rem;
        height: 3.49rem;
        left: -5.15rem;
    }

    100% {
        opacity: 1;
        width: 7rem;
        height: 5.49rem;
        left: -2.4rem;
    }
}

@keyframes girl3 {
    0% {
        opacity: 0;
        right: -3.15rem;
    }

    //  50%{opacity:.8; }
    100% {
        opacity: 1;
        right: -2.02rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/h5page/h5home.vue